import request from '@/lib/request/'

const baseUri = 'dashboard/'

/**
 * @returns {Promise}
 */
export function get () {
  return request({
    url: baseUri,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/dashboard/index.js